/*@ngInject*/
const TaskGridMediator = function (bulkResolveRepository, bulkReassignRepository) {


    this.resolveTaskList = function (params, resolutionNotes) {
        return bulkResolveRepository.resolve(params, resolutionNotes);
    };

    this.reassignTaskList = function (params, assignee) {
        return bulkReassignRepository.reassign(params, assignee);
    };
};

angular.module('umLanding').service('taskGridMediator', TaskGridMediator);
